import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavBar = ({ user }) => {
	const showRegister = false; //!user ? false : user.role === "admin" ? true : false;

	return (
		<Navbar variant="dark" className="mynavbar">
			{/* <Navbar.Brand href="#home"><FontAwesomeIcon icon="home" /></Navbar.Brand> */}
			<Nav className="mr-auto">
				{user && (
					<React.Fragment>
						<Nav.Link href="\">
							<FontAwesomeIcon icon="home" />
							&nbsp;Home
						</Nav.Link>
						<Nav.Link href="\search">
							<FontAwesomeIcon icon="search" />
							&nbsp;Search
						</Nav.Link>
						<Nav.Link href="\aircraft\add">
							<FontAwesomeIcon icon="plane" />
							&nbsp;Aircraft
						</Nav.Link>
						<Nav.Link href="\manufacturer\add">
							<FontAwesomeIcon icon="tools" />
							&nbsp;Brands
						</Nav.Link>
						<Nav.Link href="\sponsors\list">
							<FontAwesomeIcon icon="dollar-sign" />
							&nbsp;Sponsors
						</Nav.Link>
						<Nav.Link href="\issues">
							<FontAwesomeIcon icon="envelope" />
							&nbsp;Feedback
						</Nav.Link>
					</React.Fragment>
				)}
				{!user && (
					<React.Fragment>
						<Nav.Link href="\login">
							<FontAwesomeIcon icon="pencil-alt" />
							&nbsp;Login
						</Nav.Link>
						<Nav.Link href="\contact-us">
							<FontAwesomeIcon icon="pencil-alt" />
							&nbsp;Contact Us
						</Nav.Link>
					</React.Fragment>
				)}
				{showRegister && <Nav.Link href="\register">Register</Nav.Link>}
				{user && (
					<React.Fragment>
						<Nav.Link href="\profile" className="navlink_profile">
							<FontAwesomeIcon icon="user-circle" />
							&nbsp;{user.firstName}
						</Nav.Link>
						<Nav.Link href="\logout">Logout</Nav.Link>
					</React.Fragment>
				)}
			</Nav>
		</Navbar>
	);
};

export default NavBar;
